import { callApiToServer } from "../callApi";

export async function addSubUser(authtoken, subUserObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      email: subUserObject.email,
      password: subUserObject.password,
      user_id: subUserObject.user_id,
    });

    let endUrl = "v1/auth/sub-user";

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
